import { ListItemText, Menu, MenuItem } from '@mui/material';
import i18next from 'i18next';
import React, { useState } from 'react';

import { MENU_PAPER_STYLE } from '@commons/utils/dataGrid';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import {
  BasicHeaderLabel,
  HeaderLabelsContainer,
  MenuItemIcon,
  TimeSlotHeaderContainer,
  TimeSlotHeaderWithMenuContainer,
  TimeSlotMenuButton,
  TimeSlotMenuIcon,
  ToProduceHeaderLabel,
} from './styledComponents';

import { formatTime } from '../utils';

// Custom header component for timeSlots
export const TimeSlotHeader = ({
  timeSlot,
  showMenu = false,
  onFillTimeSlotProduction,
  onClearTimeSlotQuantities,
  enableFillProduction = true,
  enableClearQuantities = true,
  showProducedColumn = true,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleFillProduction = () => {
    onFillTimeSlotProduction?.(timeSlot.id);
    handleMenuClose();
  };

  const handleClearQuantities = () => {
    onClearTimeSlotQuantities?.(timeSlot.id);
    handleMenuClose();
  };

  return (
    <TimeSlotHeaderWithMenuContainer>
      <TimeSlotHeaderContainer>
        <Text
          color={ENUM_COLORS.DARKEST}
          font={ENUM_FONTS.TEXT_BIG_HEIGHT_24}
          style={{
            marginBottom: '4px',
            textAlign: 'start',
          }}
        >
          {timeSlot.name} {formatTime(timeSlot.startTime)}-{formatTime(timeSlot.endTime)}
        </Text>

        <HeaderLabelsContainer>
          <BasicHeaderLabel>
            <Text color={ENUM_COLORS.DARK} font={ENUM_FONTS.TEXT_MICRO_HEIGHT_12}>
              {i18next.t('PRODUCTION.PLANNING.FORECAST', { count: 0 })}
            </Text>
          </BasicHeaderLabel>

          <BasicHeaderLabel>
            <Text color={ENUM_COLORS.DARK} font={ENUM_FONTS.TEXT_MICRO_HEIGHT_12}>
              {i18next.t('PRODUCTION.PLANNING.STOCK')}
            </Text>
          </BasicHeaderLabel>

          <ToProduceHeaderLabel>
            <Text color={ENUM_COLORS.DARK} font={ENUM_FONTS.TEXT_MICRO_HEIGHT_12}>
              {i18next.t('PRODUCTION.PLANNING.TO_PRODUCE')}
            </Text>
          </ToProduceHeaderLabel>

          {showProducedColumn && (
            <BasicHeaderLabel>
              <Text color={ENUM_COLORS.DARK} font={ENUM_FONTS.TEXT_MICRO_HEIGHT_12}>
                {i18next.t('PRODUCTION.PLANNING.PRODUCED')}
              </Text>
            </BasicHeaderLabel>
          )}
        </HeaderLabelsContainer>
      </TimeSlotHeaderContainer>

      {showMenu && (
        <>
          <TimeSlotMenuButton isActive={open} onClick={handleMenuClick}>
            <TimeSlotMenuIcon
              isActive={open}
              src="/images/inpulse/ellipsis-vertical-black-small.svg"
            />
          </TimeSlotMenuButton>
          <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            open={open}
            slotProps={{
              paper: {
                sx: MENU_PAPER_STYLE,
              },
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            onClose={handleMenuClose}
          >
            {enableFillProduction && (
              <MenuItem onClick={handleFillProduction}>
                <MenuItemIcon src="/images/inpulse/bolt-black-small.svg" />
                <ListItemText>
                  {i18next.t('PRODUCTION.PLANNING.FILL_TIMESLOT_PRODUCTION')}
                </ListItemText>
              </MenuItem>
            )}
            {enableClearQuantities && (
              <MenuItem onClick={handleClearQuantities}>
                <MenuItemIcon src="/images/inpulse/trash-black-small.svg" />
                <ListItemText>{i18next.t('PRODUCTION.PLANNING.CLEAR_QUANTITIES')}</ListItemText>
              </MenuItem>
            )}
          </Menu>
        </>
      )}
    </TimeSlotHeaderWithMenuContainer>
  );
};
